export default {
    A1: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'outbound link click',
        'buttonLocation': 'mid', 
        'siteSection': 'outbound link',
        'clickText': '{{lower case click text}}' //e.g., "rocky mountain institute"
    }, 
    A2: 
        {
            'event': 'key-interaction',
            'lineOfBusiness': 'ent: interaction',
            'userActionTaken': 'navigate',
            'buttonLocation': 'anchor', 
            'siteSection': 'anchor',
            'clickText': '{{superscript number}}' // e.g., '1', '2' - the text from the superscript
        }
}